<template>
	<div>
		<modalpassword ref="modalpassword" @action="changePassword"></modalpassword>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Profile</div>
		</div>
		<v-col cols="12" md="12" class="pa-0 mt-3">
			<v-card class="overflow-hidden" outlined>
				<v-card-text class="pb-0">
					<v-row>
						<v-col cols="5" md="2" class="text-center">
							<v-hover v-slot:default="{ hover }">
								<v-avatar color="grey" size="120">
									<img class="avatar" :src="userData.user_supplier_image">
									<v-expand-transition>
										<div v-if="hover" class="d-flex transition-fast-in-fast-out cyan darken-2 v-card--reveal white--text" style="height: 100%;">
											<v-file-input dark color="white" @change="handleFileUpload($event)" accept="image/png, image/jpeg, image/jpg" prepend-icon="mdi-camera" hide-input hide-details class="icon-upload-avatar-profile">
											</v-file-input>
										</div>
									</v-expand-transition>
								</v-avatar>
							</v-hover>
						</v-col>
						<v-col cols="7" md="10" class="text-center">
							<div class="mb-3 text-right">
								<v-btn dark depressed color="cyan darken-2" @click="showModalPassword">
									<v-icon small class="pr-2">mdi-key</v-icon>
									Ubah Kata Sandi
								</v-btn>
							</div>
							<v-row>
								<v-col cols="12" md="6" class="text-center">
									<v-text-field disabled label="Username" v-model="userData.user_supplier_username" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="text-center">
									<v-text-field :disabled="!isEditing" label="Nama" v-model="name" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="text-center">
									<v-text-field :disabled="!isEditing" label="Nomor Handphone" v-model="mobilephone" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="text-center">
									<v-text-field :disabled="!isEditing" v-model="email" :rules="emailRules" label="E-mail" required outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="text-center">
									<v-autocomplete disabled :items="OptionType" item-text="type_name" label="Tipe" v-model="userData.user_supplier_type" outlined dense no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="mx-2">
					<v-spacer></v-spacer>
					<v-btn dark outlined v-if="isEditing" color="grey darken-1" @click="isEditing = !isEditing">
						<v-icon small class="pr-2">mdi-close</v-icon>
						Batal
					</v-btn>
					<v-btn dark depressed v-if="isEditing" color="cyan darken-2" @click="save">
						<v-icon small class="pr-2">mdi-check</v-icon>
						Simpan
					</v-btn>
					<v-btn dark depressed v-if="!isEditing" color="cyan darken-2" @click="isEditing = !isEditing">
						<v-icon small class="pr-2">mdi-pencil</v-icon>
						Ubah
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
		<v-snackbar v-model="hasSaved" :timeout="2000" absolute top right color="light-blue">
			Your profile has been updated
		</v-snackbar>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
import modalpassword from '@/views/MLsupplier/profile/ModalPasswordProfile'

export default {
	components: {
		modalpassword
	},
	data() {
		return {
			formData: new FormData(),
			image: '',
			name: '',
			email: '',
			mobilephone: '',
			hasSaved: false,
			isEditing: null,
			model: null,
			emailRules: [
			v => !!v || 'E-mail is required',
			v => /.+@.+/.test(v) || 'E-mail must be valid',
			],
		}
	},
	computed: {
		...mapState('authSupplier', ['userData']),
		...mapState('userSupplier', ['OptionType', 'responSukses']),
	},
	methods: {
		...mapActions('userSupplier', ['getTypeOption', 'updatePassword', 'changeImage', 'update']),
		...mapMutations('userSupplier', ['clearDataUser', 'saveResponse']),

		handleFileUpload(event) {
			this.formData.append('image', event);
			this.changeImage(this.formData).then( () => {
				if (this.responSukses.code == 200) {
					this.saveResponse({})
					// this.image = this.imageName
				}
			})
		},
		showModalPassword(){
			this.$refs.modalpassword.show()
		},
		changePassword(params) {
			this.updatePassword(params).then(() => {
				if (this.responSukses.code == 200) {
					this.saveResponse({})
					this.$refs.modalpassword.hide()
				}
			})
		},
		save () {
			this.isEditing = !this.isEditing
			let params = {
				id : this.userData.user_supplier_id,
				name : this.name,
				email : this.email,
				mobilephone : this.mobilephone,
			}
			this.update(params)
		},
		setDataToUserData(){
			this.name = this.userData.user_supplier_name
			this.email = this.userData.user_supplier_email
			this.mobilephone = this.userData.user_supplier_mobilephone
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Profil`)
		this.getTypeOption()
		this.setDataToUserData()
	},
	beforeDestroy(){
		this.clearDataUser()
	}
}
</script>